import { useEffect } from 'react';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import PopularVideos from './components/PopularVideos';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '樱花视频',
      url: 'https://sakuracam.github.io',
      description: '专注樱花主题的高清视频平台，汇聚全球樱花盛开实录、延时摄影、旅行Vlog及赏樱攻略',
      foundingDate: '2024',
    },
    {
      '@type': 'WebSite',
      name: '樱花视频',
      url: 'https://sakuracam.github.io',
      description: '高清樱花视频在线观看平台，足不出户赏最美樱花',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://sakuracam.github.io/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://sakuracam.github.io/#webpage',
      url: 'https://sakuracam.github.io',
      name: '樱花视频 - 首页',
      isPartOf: { '@id': 'https://sakuracam.github.io/#website' },
      about: { '@id': 'https://sakuracam.github.io/#organization' },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    document.title = '樱花视频 - 高清樱花视频在线观看平台 | 足不出户赏最美樱花';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '樱花视频是专注于樱花主题的高清视频平台，汇聚全球各地樱花盛开实录、延时摄影、旅行Vlog及赏樱攻略视频。带你足不出户欣赏最美樱花季，感受春日浪漫。');
    }
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute('content', '樱花视频,樱花视频在线观看,高清樱花视频,樱花延时摄影视频,日本樱花视频,樱花盛开视频,赏樱旅行视频');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryNav />
        <PopularVideos />
        <FeaturedArticles />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}